// Middleware
import AuthMiddleware from '@middleware/AuthMiddleware';

// Layouts
import LayoutConsole from '@layouts/LayoutConsole';

// Pages
import PageAutomations from '@pages/automations';
import PageAutomationsEdit from '@pages/automations-edit';
import PageBroadcasts from '@pages/broadcasts';
import PageBroadcastsEdit from '@pages/broadcasts-edit';
import PageCampaignsMember from '@pages/campaigns-member';
import PageCampaignsMemberEvents from '@pages/campaigns-member/PageCampaignsMemberEvents';
import PageCampaignsMemberJourney from '@pages/campaigns-member/PageCampaignsMemberJourney';
import PageCampaignsMemberJourneys from '@pages/campaigns-member/PageCampaignsMemberJourneys';
import PageCampaignsMembers from '@pages/campaigns-members';
import PageCampaignsMessages from '@pages/campaigns-messages';
import PageCustomer from '@pages/customer';
import PageCustomerCharges from '@pages/customer/PageCustomerCharges';
import PageCustomerEvents from '@pages/customer/PageCustomerEvents';
import PageCustomerPages from '@pages/customer/PageCustomerPages';
import PageCustomerTraits from '@pages/customer/PageCustomerTraits';
import PageCustomers from '@pages/customers';
import PageEvents from '@pages/events';
import PageEventsEdit from '@pages/events-edit';
import PageEventsCustomers from '@pages/events-customers';
import PageExports from '@pages/exports';
import PageForms from '@pages/forms';
import PageFormsEdit from '@pages/forms-edit';
import PageInstall from '@pages/install';
import PageInstallHome from '@pages/install/PageInstallHome';
import PageInstallSegment from '@pages/install/PageInstallSegment';
import PageInstallStripe from '@pages/install/PageInstallStripe';
import PageProjects from '@pages/projects';
import PageProjectsMessages from '@pages/projects-messages';
import PageRewards from '@pages/rewards';
import PageSegments from '@pages/segments';
import PageSegmentsEdit from '@pages/segments-edit';
import PageTags from '@pages/tags';
import PageTagsEdit from '@pages/tags-edit';
import PageTemplates from '@pages/templates';
import PageTemplatesEdit from '@pages/templates-edit';
import PageTraits from '@pages/traits';
import PageTraitsEdit from '@pages/traits-edit';

export default {
    path: '/',
    name: 'console',
    component: LayoutConsole,
    redirect: {
        name: 'customers',
    },
    meta: {
        middleware: [
            AuthMiddleware,
        ],
    },
    children: [
        {
            path: 'projects',
            name: 'projects',
            component: PageProjects,
            meta: {
                title: 'Projects'
            }
        },
        {
            path: 'projects/:id/messages',
            name: 'projects-messages',
            component: PageProjectsMessages,
            meta: {
                title: 'Project Messages'
            }
        },
        {
            path: 'install',
            component: PageInstall,
            children: [
                {
                    path: '',
                    name: 'install',
                    component: PageInstallHome,
                    meta: {
                        title: 'Install',
                    },
                },
                {
                    path: 'stripe',
                    name: 'install-stripe',
                    component: PageInstallStripe,
                    meta: {
                        title: 'Install | Stripe',
                    },
                },
                {
                    path: 'segment',
                    name: 'install-segment',
                    component: PageInstallSegment,
                    meta: {
                        title: 'Install | Segment',
                    },
                },
            ],
        },
        {
            path: 'customers',
            name: 'customers',
            component: PageCustomers,
            meta: {
                title: 'Customers'
            },
        },
        {
            path: 'customers/:id',
            name: 'customer',
            component: PageCustomer,
            redirect: {
                name: 'customer-events',
            },
            meta: {
                title: 'Customer',
            },
            children: [
                {
                    path: 'events',
                    name: 'customer-events',
                    component: PageCustomerEvents,
                    meta: {
                        title: 'Customer | Events',
                    },
                },
                {
                    path: 'traits',
                    name: 'customer-traits',
                    component: PageCustomerTraits,
                    meta: {
                        title: 'Customer | Traits',
                    },
                },
                {
                    path: 'pages',
                    name: 'customer-pages',
                    component: PageCustomerPages,
                    meta: {
                        title: 'Customer | Pages',
                    },
                },
                {
                    path: 'charges',
                    name: 'customer-charges',
                    component: PageCustomerCharges,
                    meta: {
                        title: 'Customer | Charges',
                    },
                },
            ],
        },
        {
            path: 'segments',
            name: 'segments',
            component: PageSegments,
            meta: {
                title: 'Segments',
            },
        },
        {
            path: 'segments/:id',
            name: 'segments-edit',
            component: PageSegmentsEdit,
            meta: {
                title: 'Edit Segment',
            },
        },
        {
            path: 'tags',
            name: 'tags',
            component: PageTags,
            meta: {
                title: 'Tags',
            },
        },
        {
            path: 'tags/:id',
            name: 'tags-edit',
            component: PageTagsEdit,
            meta: {
                title: 'Edit Tag',
            },
        },
        {
            path: 'templates',
            name: 'templates',
            component: PageTemplates,
            meta: {
                title: 'Templates',
            },
        },
        {
            path: 'templates/:id',
            name: 'templates-edit',
            component: PageTemplatesEdit,
            meta: {
                title: 'Edit Template',
            },
        },
        {
            path: 'events',
            name: 'events',
            component: PageEvents,
            meta: {
                title: 'Events'
            }
        },
        {
            path: 'events/:id',
            name: 'events-edit',
            component: PageEventsEdit,
            meta: {
                title: 'Edit Event'
            }
        },
        {
            path: 'events/:id/customers',
            name: 'events-customers',
            component: PageEventsCustomers,
            meta: {
                title: 'Event Performers'
            }
        },
        {
            path: 'traits',
            name: 'traits',
            component: PageTraits,
            meta: {
                title: 'Traits',
            },
        },
        {
            path: 'traits/:id',
            name: 'traits-edit',
            component: PageTraitsEdit,
            meta: {
                title: 'Edit Trait',
            },
        },
        {
            path: 'broadcasts',
            name: 'broadcasts',
            component: PageBroadcasts,
            meta: {
                title: 'Broadcasts'
            }
        },
        {
            path: 'broadcasts/:id',
            name: 'broadcasts-edit',
            component: PageBroadcastsEdit,
            meta: {
                title: 'Edit Broadcast',
            },
        },
        {
            path: 'automations',
            name: 'automations',
            component: PageAutomations,
            meta: {
                title: 'Automations'
            }
        },
        {
            path: 'automations/:id',
            name: 'automations-edit',
            component: PageAutomationsEdit,
            meta: {
                title: 'Edit Automation',
            },
        },
        {
            path: 'campaigns/:id/messages',
            name: 'campaigns-messages',
            component: PageCampaignsMessages,
            meta: {
                title: 'Campaign Messages',
            },
        },
        {
            path: 'campaigns/:id/members',
            name: 'campaigns-members',
            component: PageCampaignsMembers,
            meta: {
                title: 'Campaign Members',
            },
        },
        {
            path: 'members/:id',
            name: 'campaigns-member',
            component: PageCampaignsMember,
            meta: {
                title: 'Campaign Member',
            },
        },
        {
            path: 'members/:id/journeys',
            name: 'campaigns-member-journeys',
            component: PageCampaignsMemberJourneys,
            meta: {
                title: 'Campaign Member | Journeys',
            },
        },
        {
            path: 'members/:id/journeys/:journey_id',
            name: 'campaigns-member-journey',
            component: PageCampaignsMemberJourney,
            meta: {
                title: 'Campaign Member | Journey',
            },
        },
        {
            path: 'members/:id/events',
            name: 'campaigns-member-events',
            component: PageCampaignsMemberEvents,
            meta: {
                title: 'Campaign Member | Events',
            },
        },
        {
            path: 'exports',
            name: 'exports',
            component: PageExports,
            meta: {
                title: 'Exports'
            }
        },
        {
            path: 'forms',
            name: 'forms',
            component: PageForms,
            meta: {
                title: 'Forms'
            }
        },
        {
            path: 'forms/:id',
            name: 'forms-edit',
            component: PageFormsEdit,
            meta: {
                title: 'Edit Form',
            },
        },
        {
            path: 'rewards',
            name: 'rewards',
            component: PageRewards,
            meta: {
                title: 'Rewards',
            },
        },
    ]
}